import { NgModule } from '@angular/core';

// libs
import { UpsIonicCoreModule } from '@ups/xplat/ionic/core';

@NgModule({
  imports: [UpsIonicCoreModule],
})
export class CoreModule {}
